// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"d9e432f8","453":"221ce7f0","810":"28ffd5b5","911":"2873a4ad"}[chunkId] + ".chunk.js";
};